import React, { useEffect, useRef, useState } from "react";
import { HiPaperClip, HiDownload } from "react-icons/hi";

import { base_url } from "../../utils/AxiosConfig";
import axios from "axios";

const DocumentManagement = () => {
  const fileInputRef = useRef(null);

  const [department, setDepartment] = useState("-");
  const [expiryDate, setExpiryDate] = useState(null);
  const [documentType, setDocumentType] = useState("");
  const [remarks, setRemarks] = useState("");
  const [departmentListFromAPI, setDepartmentListFromAPI] = useState([]);
  const [file, setFile] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    getDepartmentList();
  }, []);

  const getDepartmentList = async () => {
    const storedUserDataArray =
      JSON.parse(localStorage.getItem("BondTimeuserDataArray")) || [];
    let companyCode = null;

    if (storedUserDataArray) {
      companyCode = storedUserDataArray[0].cmpcode;
    }

    const response = await axios.get(
      `${base_url}/api/MASTERLIST/${companyCode}/DEPARTMENT/-`,
    );
    if (response?.data) {
      let newArray = response.data.filter(
        (itemFilly) => itemFilly.Description != "",
      );

      setDepartmentListFromAPI(newArray.map((i) => i.Description));
    } else {
      console.log("error");
    }
  };

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];

    if (!selectedFile) return;

    const allowedTypes = [
      "application/pdf",
      "application/msword",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      "application/vnd.ms-excel",
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      "text/plain",
    ];

    if (!allowedTypes.includes(selectedFile.type)) {
      setError("Invalid file type");
      setFile(null);
      return;
    }

    if (selectedFile.size > 5 * 1024 * 1024) {
      setError("File must be less than 5MB");
      setFile(null);
      return;
    }

    setError("");
    setFile(selectedFile);
  };

  const onSaveDocument = () => {
    console.log("onSaveDocument is clicked");
  };

  return (
    <div className="w-full">
      <div className="max-w-md">
        <div className="flex justify-left items-center mb-6">
          <div className="w-1 h-8 bg-gradient-to-r from-[#2663EB] to-blue-400 rounded-full  mr-2"></div>
          <h6 className="text-xl font-bold text-gray-900 flex items-center gap-4">
            <span className="bg-gradient-to-r from-[#2663EB] to-blue-600 bg-clip-text text-transparent">
              DOCUMENT ATTACHMENT
            </span>
          </h6>
        </div>

        <div>
          <label className="form-label fs-small text-secondary">
            Department
          </label>

          <select
            value={department || "-"}
            onChange={(e) => setDepartment(e.target.value)}
            className="w-full border border-gray-300 rounded px-2 py-1 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
          >
            <option value="-">None</option>

            {departmentListFromAPI?.map((b) => (
              <option key={b.DEPTNO} value={b}>
                {b}
              </option>
            ))}
          </select>
        </div>

        <div className="mb-2">
          <label className="form-label fs-small text-secondary">
            Expiry Date
          </label>
          <input
            type="date"
            className="form-control"
            id="expiryDate"
            name="expiryDate"
            value={expiryDate}
            onChange={(e) => setExpiryDate(e.target.value)}
            max={new Date().toISOString().split("T")[0]}
          />
        </div>

        <div className="mb-2">
          <label className="form-label fs-small text-secondary">
            Document Type
          </label>
          <input
            className="form-control"
            id="documentType"
            name="documentType"
            value={documentType}
            onChange={(e) => setDocumentType(e.target.value)}
          />
        </div>

        <div className="mb-2">
          <label className="form-label fs-small text-secondary">Remarks</label>
          <input
            className="form-control"
            id="remarks"
            name="remarks"
            value={remarks}
            onChange={(e) => setRemarks(e.target.value)}
          />
        </div>

        {/* File display + button */}
        <div className="flex items-center gap-3 border rounded-lg px-3 py-2 bg-gray-50">
          <span className="text-xs text-gray-600 truncate flex-1">
            {file?.name || "No file selected"}
          </span>

          <button
            type="button"
            onClick={() => fileInputRef.current.click()}
            className="flex items-center gap-1 px-3 py-1.5 text-xs bg-blue-500 text-white rounded hover:bg-blue-600 transition"
          >
            <HiPaperClip className="text-sm" />
            Upload
          </button>
        </div>

        {/* Hidden input */}
        <input
          ref={fileInputRef}
          type="file"
          accept=".pdf,.doc,.docx,.xls,.xlsx,.txt"
          onChange={handleFileChange}
          className="hidden"
        />

        {/* Error */}
        {error && <p className="text-red-500 text-xs mt-1">{error}</p>}
      </div>
      <div className="flex items-center justify-left">
        <button
          // type="button"
          onClick={onSaveDocument}
          className="mt-4 flex items-center justify-center gap-1 px-3 py-1.5 text-xs bg-blue-500 text-white rounded hover:bg-blue-600 transition"
        >
          <HiDownload className="text-sm" />
          Save
        </button>
      </div>
      <div>{/* Table  */}</div>
    </div>
  );
};

export default DocumentManagement;
